export function useSmoothScroll() {
  const scrollToId = (id: string) => {
    if (typeof window === 'undefined') return
    const el = document.getElementById(id)
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }

  return { scrollToId }
}
